import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";


export const OpeningStockList: React.FC = () => {
   const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);
  // Header
  useEffect(() => {
  updateMainHeader("Inventory");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);


  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Customer Management": "/customer/list" },
  ]);

   const source = {
    url: "opening-stock/list",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };

 
  const columns: IColumns[] = [
    { header: "Item Name", fieldName: "ItemName" },
    { header: "Warehouse", fieldName: "WarehouseName" },
    { header: "Quantity", fieldName: "Quantity" },
    { header: "Created date", fieldName: "CreatedDate",type:"date" },
    // { header: "Created By", fieldName: "CreatedBy",type:"date" },
    { header: "Remarks", fieldName: "Remarks" },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        const OpeningStockId = row.OpeningStockId ;
        if (!OpeningStockId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid warehouse data - missing ID", "error");
          return;
        }
        
        if (action === "Edit") {
          navigate(`/openingstock/${OpeningStockId}`);
        } else if (action === "Delete") {
          setSelectedId(OpeningStockId);
          setPopupOpen(true);
        }
      },
    },
   
  ];

  // Filters (UI only)
  

  const handleClick = () => {
    navigate("/openingstock");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="openingstockGrid"
            title="Open Stock Entry"
            headerType="modern"
            columns={columns}
            source={source}
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            addButton={{ label: "  Opening stock", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
       <ConfirmationPopup
          type="DELETE"
          apiUrl="opening-stock"  
          id={selectedId}
          confirmMessage="Are you sure you want to delete this openingstock?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("openingstockGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail, "error");
            }
          }}
        />
    </Grid>
  );
};